<label [attr.for]="'logisticsRequests'">{{ ('Logistics Request' | translate) + ':' }}</label>
<select id="logisticsRequests" [(ngModel)]="logisticsRequestObj" (change)="onLogisticsRequestChange($event)">
  <option *ngFor="let value of logisticsRequests" [ngValue]="value">{{ value.name }}</option>
</select>
<label [attr.for]="'stateLogisticsRequest'">{{ ('States' | translate) + ':' }}</label>
<select id="stateLogisticsRequest" [(ngModel)]="currentState" (change)="onStateChange($event)">
  <option *ngFor="let value of states" [ngValue]="value">{{ value.replace('_', ' ') }}</option>
</select>